import ABSService from "./absService";

class LyDoService extends ABSService {
    constructor() {
        super("lydo");
    }
}

export default LyDoService;